import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import i18n from "i18next";

import { DefaultRowCell } from "../../../../Layout/SortedList";
import { checkIsInternalUser } from "../../../../../helpers/Authorization/authorizationHelpers";
import { formatDate } from "../../../../../helpers/dateHelpers";
import { formatDimension, formatQuantityValue } from "../../../../../helpers/unitOfMeasurementHelpers";
import DeliveryStatusCell from "./DeliveryStatusCell";
import DisplayFullDataButton from "../../../../Layout/SortedList/DisplayFullDataButton";

export default class ListRow extends PureComponent {
  static propTypes = {
    isFullDataDisplayed: PropTypes.bool,
    isMobile: PropTypes.bool,
    item: PropTypes.object,
    onDisplayFullData: PropTypes.func,
    userMetadata: PropTypes.object
  };

  static defaultProps = {
    isFullDataDisplayed: false,
    isMobile: false,
    item: {},
    onDisplayFullData: null,
    userMetadata: {}
  };

  state = {
    hasOverflowedChild: false
  };

  handleOverflowedChildState = () => {
    this.setState({
      hasOverflowedChild: true
    });
  };

  render() {
    const { isFullDataDisplayed, isMobile, item, onDisplayFullData, userMetadata } = this.props;
    const { orderedProduct = {}, mill = {} } = item;
    const { hasOverflowedChild } = this.state;
    const isInternal = checkIsInternalUser();

    return (
      <div role="row" tabIndex="0" className={classNames("sorted-list__row", isFullDataDisplayed && "--full-data-displayed")}>
        <DefaultRowCell
          className="--first --x3"
          header={isMobile ? i18n.t("purchaseOrder.number") : ""}
          onOverflowedChild={this.handleOverflowedChildState}
          value={item.customerPOId}
        />
        <DefaultRowCell
          className="--x2"
          header={isMobile ? i18n.t("purchaseOrder.endUser") : ""}
          onOverflowedChild={this.handleOverflowedChildState}
          value={item.endUserId}
        />
        {isInternal && (
          <DefaultRowCell
            className="--x1"
            header={isMobile ? i18n.t("purchaseOrder.mill") : ""}
            onOverflowedChild={this.handleOverflowedChildState}
            value={mill.millId}
          />
        )}
        <DefaultRowCell
          className="--x4"
          onOverflowedChild={this.handleOverflowedChildState}
          header={isMobile ? i18n.t("products.product") : ""}
          value={orderedProduct.productName}
        />
        <DefaultRowCell
          className="--x2"
          onOverflowedChild={this.handleOverflowedChildState}
          header={isMobile ? i18n.t("products.dimensions") : ""}
          value={formatDimension(orderedProduct.dimension)}
        />
        <DefaultRowCell
          className="--right --x2"
          header={isMobile ? i18n.t("purchaseOrder.ordered") : ""}
          onOverflowedChild={this.handleOverflowedChildState}
          value={formatQuantityValue(orderedProduct.quantityAcknowledged)}
        />
        <DefaultRowCell
          className="--x2"
          header={isMobile ? i18n.t("purchaseOrder.delivery") : ""}
          onOverflowedChild={this.handleOverflowedChildState}
          value={formatDate(item.deliveryDate, userMetadata.dateDisplayFormat)}
        />
        <DefaultRowCell
          className="--x2"
          header={isMobile ? i18n.t("purchaseOrder.pressDate") : ""}
          onOverflowedChild={this.handleOverflowedChildState}
          value={formatDate(item.pressDate, userMetadata.dateDisplayFormat)}
        />
        <DeliveryStatusCell className="--x2" deliveryDays={item.deliveryDays} deliveryStatus={item.deliveryStatus} />
        {isMobile && hasOverflowedChild && <DisplayFullDataButton isFullDataDisplayed={isFullDataDisplayed} onDisplayFullData={onDisplayFullData} />}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PurchaseOrder/ListPage/List/PrePlanning/ListRow.js